import { module as BaseModule } from 'modujs';
import gsap from 'gsap';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      submit: 'newsletterSignup'
    };

    this.iObs = null;
  }

  init() {
    this.initEvents();
    this.setupIntersectionObserver();
  }

  initEvents() {
    this.$('form')[0].addEventListener('change', ev => {
      grecaptcha?.ready(() => {
        grecaptcha.execute(
          '6LcxXpMfAAAAAJrdGmd8q52znxkziFRkLqqNSpph',
          {
            action: 'newsletter'
          }
        ).then(token => {
          this.$('recaptcha')[0].setAttribute('value', token);
        });
      });
    }, { once: true });
  }

  setupIntersectionObserver() {
    if ( !window.IntersectionObserver ) {
      return;
    }

    this.iObs = new IntersectionObserver(entries => {
      entries.forEach((entry, self) => {
        if ( entry.isIntersecting ) {
          this.runAnimation();
          this.iObs.unobserve( entry.target );
        }
      });
    }, {
      threshold: [ 0.25 ],
    });

    this.iObs.observe( this.el );
  }

  runAnimation() {
    gsap.to( this.el, {
      duration: 0.8,
      opacity: 1,
      x: 0,
      ease: 'power3.out',
    } );
  }

  newsletterSignup( event ) {
    event.preventDefault();

    const responseElement = this.$('response')[0];
    const submitButton = this.$('submit')[0];
    const submitButtonOriginalContent = submitButton.innerHTML;
    const formData = new FormData( event.target );

    //for ( const field of formData.entries() ) {
    //  if ( '' === field[1] ) {
    //    this.el.querySelector(`[name='${ field[0] }']`).focus();
    //    return;
    //  }
    //}

    formData.append( 'sec', RSQ_XHR.sec );
    formData.append( 'action', 'do_newsletter' );

    submitButton.setAttribute('disabled', true);
    submitButton.children[1].innerText = 'Enviando…';
    responseElement.innerHTML = '';

    fetch(RSQ_XHR.url, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(response => {
        //console.log( response );
        if (response.success) {
          //console.log( response );
          window.setTimeout(() => {
            submitButton.parentElement.innerHTML = `<span>${ response.data.message }</span>`;
          }, 1000);
        } else {
          //const errorField = formElement.querySelector(SELECTOR.ERROR + response.data.selector);
          //errorField.innerHTML = response.data.message;
          responseElement.innerHTML = response.data.message;
          submitButton.innerHTML = submitButtonOriginalContent;
          submitButton.disabled = false;
        }
      })
      .catch(err => {
        console.error(err.message);
        //submitButton.innerHTML = submitButtonOriginalContent;
        //submitButton.disabled = false;
      })
    ;
  }
}
